module.exports = __webpack_public_path__ + "img/chayue.4cef156a.svg";